// extracted by mini-css-extract-plugin
export default {"remove-button":"configurator-web-remove-button"};